import React from "react";
import { Button, Result } from "antd";
import { Link } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { rootPath } from "../../helpers/paths";

function ErrorFallback() {
  return (
    <Result
      status="500"
      title="500"
      subTitle="Sorry, something went wrong."
      extra={
        <Link to={rootPath()}>
          <Button type="primary">Back Home</Button>
        </Link>
      }
    />
  );
}

export function JSError(props: any) {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      {props.children}
    </ErrorBoundary>
  );
}
